<template>
  <div class="filter-item-wrapper">
    <label
      :for="'input_' + identifier"
      class="label"
      :title="title || label"
    >
      <span v-html="label" />
      <InfoIcon
        v-if="hasInfoIcon"
        popup-ref="showBrandsPopup"
      />
    </label>
    <MultiSelectDropDown
      :data-items="items"
      :filterable="true"
      @change="filterChangeHandler"
      @input.stop
      :value="dropdownValues"
      :id="'input_' + identifier"
      :text-field="'label'"
      :data-item-key="'value'"
      :disabled="disabled"
      :popup-class-name="popupClassName"
    />
  </div>
</template>

<script>
import MultiSelectDropDown from '~/components/input-components/MultiSelectDropDown'
import InfoIcon from '~/components/InfoIcon.vue'

export default {
  name: 'AttributeFilterMultiSelect',
  components: {
    MultiSelectDropDown,
    InfoIcon
  },
  props: {
    filterValues: {
      type: Array || null,
      required: true,
      default() {
        return []
      }
    },
    label: {
      type: String,
      required: true,
      default () {
        return ''
      }
    },
    title: {
      type: String,
      required: false,
      default () {
        return null
      }
    },
    identifier: {
      type: Number,
      required: true,
      default () {
        return 0
      }
    },
    selectedValues: {
      type: Array || null,
      required: true,
      default() {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasInfoIcon: {
      type: Boolean,
      default() {
        return false
      }
    },
    isSorted: {
      type: Boolean,
      default() {
        return false
      }
    },
    sortDescending: {
      type: Boolean,
      default() {
        return false
      }
    },
    popupClassName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    dropdownValues: {
      get() {
        return this.selectedValues
      },
      set(val) {
        // eslint-disable-next-line eqeqeq
        if (val != null) {
          this.$emit('input', val)
        }
      }
    },
    items() {
      const descending = this.sortDescending
      function compare(a, b) {
        let result
        if (!isNaN(a.value) && !isNaN(b.value)) {
          result = +a.value - +b.value
        }
        else {
          if (a.value < b.value)
          {result = -1}
          else if (a.value > b.value)
          {result = 1}
          else
          {result = 0}
        }
        return descending ? -result : result
      }
      return this.isSorted ? this.filterValues.map(v => ({'label': v.label ?? v.value, 'value': v.value})).sort(compare) : this.filterValues.map(v => ({'label': v.label ?? v.value, 'value': v.value}))
    }
  },
  methods: {
    filterChangeHandler(event) {
      this.dropdownValues = event.value
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler(val) {
        if (val) {
          this.dropdownValues = this.items
        }
      }
    }
  }
}
</script>

<style lang="scss">
.filter-item-wrapper {
  position: relative;
  font-weight: $base-text-font-weight-light;

  .k-clear-value {
    display: none;
  }

  label .icon.infoIcon {
    position: absolute;
    top: -.5em;
  }
}

</style>
